import * as Yup from "yup";
export const validationSchemaExperienceBuilder = () => {
  return Yup.object({
    experience: Yup.object().required("Experience is required."),
    name: Yup.object().required("Author name is required."),
    body: Yup.object().required("Post body is required.")
  });
};
